import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'repeat'
})
export class RepeatPipe implements PipeTransform {
  transform(input: string, times: number = 1, separator: string = ''): string {
    let ret = input;
    while (--times) {
      ret += separator + input;
    }
    return ret;
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./node_modules/ng-pipes/src/string/repeat.pipe.ts